module.exports = __webpack_public_path__ + "static/media/promise.8f6fc865.png";